<div class="mb-5">
    <div class="flex items-center">
        @if (fieldNumber) {
            <app-form-number-indicator
                [formFieldNumber]="fieldNumber"
            ></app-form-number-indicator>
        }
        <ng-content></ng-content>
        @if (inline) {
            @if (dialogTooltip) {
                <app-dialog-tooltip
                    class="ml-[9px]"
                    [message]="tooltipMessage"
                    [title]="dialogTooltipTitle"
                    [width]="dialogWidth"
                ></app-dialog-tooltip>
            } @else {
                <app-hover-tooltip
                    class="ml-2"
                    [message]="tooltipMessage"
                ></app-hover-tooltip>
            }
        }
    </div>

    @if (tooltipMessage && !inline) {
        <div
            class="tooltip-wrapper"
            [class.pl-16]="fieldNumber"
            [class.pl-4]="!fieldNumber"
        >
            <span class="text-xs">{{
                getHintTextToDisplay() | ellipsis: ellipsisLength
            }}</span>

            @if (showTooltipIcon) {
                <app-hover-tooltip
                    class="ml-2"
                    [message]="tooltipMessage"
                ></app-hover-tooltip>
            }
        </div>
    }
</div>
